// extracted by mini-css-extract-plugin
export var md = "_68-4";
export var semantic = "_68-5";
export var sm = "_68-3";
export var text = "_68-6";
export var toggleInput = "_68-0";
export var toggleSwitch = "_68-1";
export var xs = "_68-2";